"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Storyblok = _interopRequireDefault(require("../../utils/Storyblok"));

var _sizeGrid = _interopRequireDefault(require("../../utils/sizeGrid"));

var _customProps = require("../../utils/customProps");

var _customComponents = require("../../utils/customComponents");

var _GridItem = _interopRequireDefault(require("./components/GridItem/GridItem"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Grid = function Grid(_ref) {
  var alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      rootClass = _ref.rootClass,
      direction = _ref.direction,
      justify = _ref.justify,
      wrap = _ref.wrap,
      spacing = _ref.spacing,
      content = _ref.content,
      components = _ref.components,
      style = _ref.style;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass, _objectSpread({
    padding: '25px'
  }, style));

  var gridRender = Object.keys(components);
  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    alignContent: alignContent,
    alignItems: alignItems,
    className: styles.root,
    direction: direction,
    justify: justify,
    wrap: wrap,
    spacing: Number(spacing)
  }, content.map(function (component, index) {
    if (gridRender.includes(component.component)) {
      return (0, _customComponents.renderComponents)(components, _objectSpread(_objectSpread({}, component), {}, {
        sizeGrid: _sizeGrid.default
      }), index);
    }

    return /*#__PURE__*/_react.default.createElement(_GridItem.default, (0, _extends2.default)({}, component, {
      key: index,
      components: components,
      sizeGrid: _sizeGrid.default
    }));
  }));
};

var _default = Grid;
exports.default = _default;
Grid.propTypes = {
  /**
   * developer prop to pass components to a gridItem
   */
  components: _propTypes.default.shape().isRequired,

  /**
   * stroyblok multiselect of css classes
   * Mui Override or extend the styles applied to the component. See CSS API below for more details.
   */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   * mui prop: 'stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around'
   * Defines the align-content style property. It's applied for all screen sizes.
   */
  alignContent: function alignContent(props, propName, componentName) {
    var validProp = ['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop: 'flex-start' , 'center' , 'flex-end' , 'stretch' , 'baseline'
   * Defines the align-items style property. It's applied for all screen sizes.
   */
  alignItems: function alignItems(props, propName, componentName) {
    var validProp = ['flex-start', 'center', 'flex-end', 'stretch', 'baseline'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /*
  * mui prop: 'row', 'row-reverse', 'column', 'column-reverse'
  * Defines the flex-direction style property. It is applied for all screen sizes.
  */
  direction: function direction(props, propName, componentName) {
    var validProp = ['row', 'row-reverse', 'column', 'column-reverse'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop:
   * 'flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'
   * Defines the justify-content style property. It is applied for all screen sizes.
   */
  justify: function justify(props, propName, componentName) {
    var validProp = ['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * mui prop:  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10
   * Defines the space between the type item
   component. It can only be used on a type container component.
   */
  spacing: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),

  /**
   * mui prop: 'nowrap', 'wrap', 'wrap-reverse'
   * Defines the flex-wrap style property. It's applied for all screen sizes.
   */
  wrap: function wrap(props, propName, componentName) {
    var validProp = ['nowrap', 'wrap', 'wrap-reverse'];
    return (0, _customProps.muiStringProp)(props, propName, componentName, validProp);
  },

  /**
   * Content passed to render
   */
  content: _propTypes.default.arrayOf(_propTypes.default.shape({
    component: _propTypes.default.string.isRequired
  })).isRequired,

  /** style obj to pass to grid */
  style: _propTypes.default.shape()
};
Grid.defaultProps = {
  alignContent: 'stretch',
  alignItems: 'center',
  rootClass: [],
  direction: 'row',
  justify: 'center',
  spacing: '2',
  wrap: 'wrap',
  style: {}
};